import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>00:00</span>Intro</li>
                            <li><span>00:40</span>Getting started with Mergers and Acquisitions</li>
                            <li><span>03:57</span>Perfecting the structure for M&A</li>
                            <li><span>06:32</span>Going from a startup to a successful exit</li>
                            <li><span>09:22</span>The opportunity to build a better capital</li>
                            <li><span>12:17</span>Entrepreneurs are the change agents</li>
                            <li><span>19:57</span>Making small businesses investible asset class</li>
                            <li><span>20:20</span>The role of Harbour Club</li>
                            <li><span>22:35</span>5 years down the road</li>
                            <li><span>24:46</span>What brings Jeremy to Dubai?</li>
                            <li><span>29:20</span>The checklist to get into M&A</li>
                            <li><span>32:24</span>Strategic Acquisitions vs Opportunistic Acquisitions</li>
                            <li><span>35:42</span> The stepping stone to getting into M&A</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;